import React, {FC} from 'react'
import {Alert, Button} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'

type AlertProps = {
  variant: string
  dtIcon?: string
  faIcon?: string | JSX.Element
  title?: string
  description: JSX.Element
  children?: JSX.Element
  dismissible?: boolean
}

const Alertize: FC<AlertProps> = ({variant, dtIcon, faIcon, title, description, children, dismissible}) => {
  return (
    <Alert variant={variant} className='d-flex p-5 mb-4'>
      {dtIcon != null && (
        <KTSVG path={`/media/icons/duotune/${dtIcon}.svg`} className={`svg-icon svg-icon-2hx align-self-center me-5 text-${variant}`} />
      )}
      {faIcon != null && (typeof faIcon === 'string' ? <i className={`${faIcon} fa-fw fa-2x align-self-center me-5 text-${variant}`}></i> : faIcon)}
      <div className='d-flex flex-column justify-content-center gap-1'>
        {title != null && <h5 className={`m-0 lh-1 fw-bold fs-6 text-${variant}`}>{title}</h5>}
        <span className='fs-7'>{description}</span>
      </div>
      {
        <div className='ms-auto d-flex align-items-center'>
          <div className='ms-5'>{children}</div>
        </div>
      }
      {!children && dismissible && (
        <Button variant='icon' className='ms-auto' data-bs-dismiss='alert'>
          <KTSVG path={`/media/icons/duotune/arrows/arr011.svg`} className={`svg-icon svg-icon-1 align-self-start ms-5 text-${variant}`} />
        </Button>
      )}
    </Alert>
  )
}

export default Alertize
